export const instanceMembersMessages = {
  en: {
    btnIsolate: 'Isolate',
    actionColumnTitle: 'Actions',
    isolateInstances: 'Isolate Instances(s)',
    isolateInstancesTooltip: 'Hide other protocols',
    selectedStpInstances: 'Selected STP instances:',
    actions: {
      show: 'Show instance',
      hide: 'Hide instance',
    },
  },
};
